import React from "react";
import NonSubLockBox from "./NonSubLockBox";

// The Insights tab of the client dashboard.
//
// INT-015 (Backend#136): there is no market card. It rendered AI-generated
// figures ("+0.88% S&P 500", "X% this quarter") as if they were market data.
// It is removed rather than relabelled, and the market array is never read
// even if an old stored document still carries it.
//
// SEC-025: with the AI kill switch off, `GET /insights/latest` answers `null`,
// so empty is an expected state, not an error.

export const INSIGHTS_DISCLAIMER = "Educational information, not financial advice.";
export const INSIGHTS_EMPTY_COPY = "No insights to show yet. Check back later.";

export function normalizeInsights(payload) {
  const list = payload?.financialInsights;
  if (!Array.isArray(list)) return [];
  return list.filter((item) => item && typeof item === "object" && (item.title || item.description));
}

export default function InsightsPanel({ financialInsights, subscribed }) {
  const items = Array.isArray(financialInsights) ? financialInsights : [];

  return (
    <div className="row align-items-stretch">
      <div className="col-12 d-flex">
        <div className="ast-card mb-4 flex-fill">
          <h4 className="ast-card-heading mb-1">
            <i className="iconoir-sparks"></i>
            AI Financial Insights
          </h4>
          <p className="text-secondary f-400 text-14 mb-3">{INSIGHTS_DISCLAIMER}</p>
          <div className="mini-scroll-bar">
            <div>
              {items.length > 0 ? (
                items.map((item, index) => (
                  <div key={item._id || `insight-${index}`} className="ai-insight-item">
                    {item.title && <h5>{item.title}</h5>}
                    {item.description && <p>{item.description}</p>}
                  </div>
                ))
              ) : (
                <p>{INSIGHTS_EMPTY_COPY}</p>
              )}
            </div>
          </div>
          {!subscribed && <NonSubLockBox />}
        </div>
      </div>
    </div>
  );
}
